const doc = [({"quaternions-and-3d-rotation":"https://eater.net/quaternions"})];
module.exports = doc.length <= 1 ? doc[0] : doc;